// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "phylopic-index" + "." + "46b7e7c5" + ".js";
};